export const ONBOARDING_LANDING_PATH = '/onboarding-v2'
export const ONBOARDING_BANKING_PATH = '/onboarding-v2?stage=banking'
export const ONBOARDING_BANKING_INTRO_PATH =
  '/onboarding-v2?stage=banking-intro'

// `/banking/apply` maps to ?stage=banking (the application step), not a
// dedicated apply stage — the onboarding flow has only banking-intro and
// banking stages.
const REDIRECT_MAP: Record<string, string> = {
  '/banking': ONBOARDING_BANKING_PATH,
  '/banking/intro': ONBOARDING_BANKING_INTRO_PATH,
  '/banking/apply': ONBOARDING_BANKING_PATH,
}

export const getOnboardingRedirectTarget = (pathname: string): string =>
  REDIRECT_MAP[pathname] ?? ONBOARDING_LANDING_PATH
